export const WEEKDAY_LABELS = [
  'יום ראשון',
  'יום שני',
  'יום שלישי',
  'יום רביעי',
  'יום חמישי',
  'יום שישי',
  'יום שבת',
];

export const parseIsoDateLocal = (isoDate: string): Date | null => {
  const parts = isoDate.split('-').map((value) => Number(value));
  if (parts.length !== 3 || parts.some((value) => Number.isNaN(value))) {
    return null;
  }

  const [year, month, day] = parts;
  return new Date(year, month - 1, day, 12, 0, 0, 0);
};

export const formatDateDot = (isoDate: string): string => {
  const parsed = parseIsoDateLocal(isoDate);
  if (!parsed) {
    return isoDate;
  }

  const day = String(parsed.getDate()).padStart(2, '0');
  const month = String(parsed.getMonth() + 1).padStart(2, '0');
  const year = parsed.getFullYear();
  return `${day}.${month}.${year}`;
};

export const formatWeekRange = (fromDate: string, toDate: string): string =>
  `${formatDateDot(fromDate)} - ${formatDateDot(toDate)}`;

export const formatAssignmentDayLabel = (isoDate: string): string => {
  const parsed = parseIsoDateLocal(isoDate);
  if (!parsed) {
    return isoDate;
  }

  const weekday = WEEKDAY_LABELS[parsed.getDay()] ?? '';
  return `${weekday} ${formatDateDot(isoDate)}`;
};

export const getTodayIsoDate = (): string => {
  const now = new Date();
  return toIsoDate(now);
};

export const toIsoDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const shiftIsoDate = (isoDate: string, days: number): string => {
  const parsed = parseIsoDateLocal(isoDate);
  if (!parsed) {
    return isoDate;
  }

  parsed.setDate(parsed.getDate() + days);
  return toIsoDate(parsed);
};

export const resolveWeekStartFromIsoDate = (isoDate: string): string => {
  const parsed = parseIsoDateLocal(isoDate);
  if (!parsed) {
    return isoDate;
  }

  return shiftIsoDate(isoDate, parsed.getDay() * -1);
};

export const getCurrentWeekStartIsoDate = (): string => resolveWeekStartFromIsoDate(getTodayIsoDate());

export const formatWeekdayLabel = (isoDate: string): string => {
  const parsed = parseIsoDateLocal(isoDate);
  if (!parsed) {
    return isoDate;
  }

  return WEEKDAY_LABELS[parsed.getDay()] ?? isoDate;
};
